import React from 'react';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

import { ADDRESS, CONTACT_EMAIL, MAILTO, SOCIAL } from '../../site';
import Logo from '../ui/Logo';
import './siteFooter.scss';

const COLUMNS = [
  {
    heading: 'Services',
    links: [
      { href: '#pillars', label: 'Data' },
      { href: '#pillars', label: 'Dev' },
      { href: '#pillars', label: 'AI' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { href: '#why', label: 'Why us' },
      { href: '#process', label: 'How it works' },
      { href: '#contact', label: 'Contact' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="site-footer__top">
          <div className="site-footer__brand">
            <a href="#top" aria-label="BizVision Tech — back to top">
              <Logo variant="white" />
            </a>
            <p>Data, dev and AI for growing US businesses.</p>
            <div className="site-footer__social">
              <a
                href={SOCIAL.linkedin}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="BizVision Tech on LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="BizVision Tech on Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="site-footer__cols">
            {COLUMNS.map((column) => (
              <div className="site-footer__col" key={column.heading}>
                <h4>{column.heading}</h4>
                {column.links.map((link) => (
                  <a href={link.href} key={link.label}>
                    {link.label}
                  </a>
                ))}
              </div>
            ))}

            <div className="site-footer__col">
              <h4>Contact</h4>
              <a href={MAILTO}>{CONTACT_EMAIL}</a>
              <span>{ADDRESS}</span>
            </div>
          </div>
        </div>

        <div className="site-footer__bottom">
          <span>&copy; {new Date().getFullYear()} BizVision Tech. All rights reserved.</span>
          <span>A technology company for the modern American business.</span>
        </div>
      </div>
    </footer>
  );
}
